
<date-picker
  v-model="localValue"
  color="gray"
  mode="date"
  :popover="{ placement: 'bottom', visibility: 'click' }"
  :min-date="min"
  :max-date="max"
>
  <template v-slot="{ inputValue, inputEvents }">
    <div class="date-input">
      <label :for="id">{{ label }}</label>

      <input
        placeholder="mm/dd/yyyy"
        :value="inputValue"
        :id="id"
        :name="id"
        v-on="inputEvents"
      />

      <span class="close" v-show="hasClear && localValue">
        <icon-button
          icon="close"
          size="16"
          tabindex="-1"
          @click="clear"
        />
      </span>
    </div>
  </template>
</date-picker>
